import React, { useEffect, useState } from 'react';
import { Link,useLocation } from 'react-router-dom';

import '../../../index.css';
import Title from '../../../components/Title';
import {
  getContentsList,
  getContentsListWithoutYn,
} from '../../../modules/NetworkFunction';
import { useContext } from 'react';
import ShopModeContext from '../../../contexts/ShopModeContext';
import AuthContext from '../../../contexts/AuthContext';
import Modal from '../../Modal';
import ContentsModal from '../ContentsModal';
import usePaymentStatus from '../../../hooks/usePaymentStatus';
import ErrorPage from '../../Error/ErrorPage';

function ContentsMaking({ history }) {
  const { auth: token } = useContext(AuthContext);
  const { shopMode } = useContext(ShopModeContext);

  const [isContentsListLoaded, setIsContentsListLoaded] = useState(false);
  const [userContentsCount, setUserContentsCount] = useState(0);
  const { isPaid } = usePaymentStatus(token);

  const [modalOpen, setModalOpen] = useState(false);
  const [closePath, setClosePath] = useState('/mypage/contents-making');
  const location = useLocation();

  useEffect(() => {
    if (!isContentsListLoaded) {
      getContentsList(
        null,
        (response) => {
          // setUserContentsCount(response.length);
          // console.log(userContentsCount);
          const filteredResponse = response.filter(item => item.shop === shopMode);
          setUserContentsCount(filteredResponse.length);
        },
        setIsContentsListLoaded,
        (e) => {
          console.log(e);
        },
        token
      );
    }
  }, [isContentsListLoaded]);

  useEffect(() => {
    if (isContentsListLoaded && isPaid !== undefined) {
      openModal();
    }
  }, [isContentsListLoaded, isPaid]);

  const openModal = () => {
    if (!isPaid && userContentsCount >= 10&&!(location.state?.isModify ?? false)) {
      alert('무료 요금제는 콘텐츠를 10개까지 만들 수 있습니다.');
      history.push({
        pathname: '/mypage/contents-list',
      });
      return;
    }
    setModalOpen(true);
    if (
      window.location.pathname.includes(
        '/mypage/contents-making/contents-modal/image-regist'
      )&&(location.state?.isModify ?? false)
    ) {
      // 수정하기에서 콘텐츠 만들기로 넘어온 경우
      setClosePath('/mypage/contents-list');
    } else {
      history.push({
        pathname: '/mypage/contents-making/contents-modal/content-regist',
        state: {
          ...location.state,
        },
      });
      
    }
  };

  const closeModal = () => {
    setModalOpen(false);
    history.push({
      pathname: closePath,
    });
  };

  return (
    <>
      <div style={{ paddingBottom: 40, position: 'relative' }}>
        <Title title="콘텐츠 만들기" />
        <div
          className="inner-box"
          style={{
            paddingTop: '140px',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <img
            alt="smile-face"
            src="https://wizmon-bucket.s3.ap-northeast-2.amazonaws.com/wizmonImages/mobileUpload/img_empty_smile.png"
            style={{
              display: 'inline-block',
              width: '150px',
              opacity: '0.9',
              marginBottom: '20px',
            }}
          ></img>
          <p style={{ color: '#848484', marginBottom: '30px' }}>
            팝업이 뜨지 않을 경우, 아래 링크로 들어가주세요.
          </p>
          <Link to="/mypage/contents-making/contents-modal/content-regist">
            <p
              onClick={openModal}
              style={{
                height: '30px',
                display: 'flex',
                alignItems: 'center',
                color: '#FF7A00',
                cursor: 'pointer',
                fontWeight: '700',
              }}
            >
              콘텐츠 만들기 〉
            </p>
          </Link>
          <Modal open={modalOpen}>
            <ContentsModal
              history={history}
              closeModal={closeModal}
              isPaid={isPaid}
            ></ContentsModal>
          </Modal>
        </div>
      </div>
    </>
  );
}

export default ContentsMaking;
